import { mapState, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import Swal from 'sweetalert2';

import TrackerButton from '@/components/TrackerButton.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import TabBar from '@/components/TabBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Spinner from '@/components/Spinner.vue';
import PzButton from '@/components/PzButton.vue';
// import ChoroplethChart from '@/components/ChoroplethChart.vue';

import Chart from 'chart.js';
import { topojson } from 'chartjs-chart-geo';
// import Papa from 'papaparse';
import countriesTopoJson from 'world-atlas/countries-50m.json';

import { HALF_DEBOUNCE_LATENCY } from '@/constants/index';

const BlessMixin = {
  name: 'BlessMixin',

  data: () => {
    return {
      promiseGetAlumniRefresh: null,

      itvlGetAlumni: null,

      blessNo: 0,

      isLiked: false,
      count: 0,

      showPicker: false,
      result: '',

      itvlBullet: null,

      active: 0,
      // timer: null,
    };
  },

  computed: {
    ...mapState('Alumni', {
      ms_alumniBless: 'alumniBless',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    ...mapGetters('Alumni', {
      mg_blessRawList: 'blessRawList',
      mg_txtBlessRawList: 'txtBlessRawList',
      mg_countriesBlessList: 'countriesBlessList',
      mg_bulletScreenList: 'bulletScreenList',
      mg_currentBulletScreenList: 'currentBulletScreenList',
      mg_hasJoined: 'hasJoined',
      mg_mainCourseStudent: 'mainCourseStudent',
      mg_alumniStatus: 'alumniStatus',
      mg_lastQueryTime: 'lastQueryTime',
    }),

    mg_countriesBlessList_10() {
      return this.mg_countriesBlessList.slice(0, 10);
    },

    c_isGoUpWallDisabled() {
      return 0 === this.blessNo;
    },
  },

  methods: {
    ...mapActions('Alumni', {
      ma_getAlumniRefresh: 'getAlumniRefresh',
      ma_makeAlumniBless: 'makeAlumniBless',
      ma_setIdxBulletScreenList: 'setIdxBulletScreenList',
    }),

    async getAlumniRefresh() {
      await this.ma_getAlumniRefresh({
        lastQueryTime: this.mg_lastQueryTime,
      });
    },

    resetGetAlumniRefresh() {
      clearInterval(this.itvlGetAlumni);
      this.itvlGetAlumni = setInterval(() => {
        this.getAlumniRefresh();
      }, 5000);
    },

    showLike() {
      const likeDom = document.createElement('div');
      likeDom.className = this.count % 2 === 0 ? 'like' : 'like like--is-second';
      likeDom.style.willChange = 'margin-top';
      document.body.appendChild(likeDom);
      setTimeout(() => {
        document.body.removeChild(likeDom);
      }, 3900);
    },

    async makeAlumniBless() {
      await this.ma_makeAlumniBless({
        blessNo: this.blessNo,
        blessCount: this.count,
        lastQueryTime: this.mg_lastQueryTime,
      });
      this.resetGetAlumniRefresh();
      this.isLiked = false;
      this.blessNo = 0;
      this.count = 0;
    },

    like() {
      this.blessNo = 0;
      this.count++;
      this.showLike();
      if (!this.isLiked) {
        this.isLiked = true;
        setTimeout(() => {
          this.de_makeAlumniBless.flush();
        }, 5000);
      }
      this.de_makeAlumniBless();
    },

    onConfirm(value, index) {
      this.result = value;
      this.blessNo = this.mg_blessRawList[index].blessNo;
      this.count = 0;
      this.showPicker = false;
    },

    async goUpWall() {
      if (!this.mg_mainCourseStudent) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          type: 'warning',
          icon: 'warning',
          title: '快开启品职学习之旅 加入校友会吧！',
          //text: '<h6>快开启品职学习之旅</h6><h6>加入校友会吧！</h6>！',
          showConfirmButton: true,
          //timer: 3000,
        });
      }
      await this.makeAlumniBless();
      this.result = '';
    },

    showBadgeModal() {
      if (this.mg_hasJoined) {
        $(this.$refs.badgeModal).modal('show');
      }
    },

    async BlessMixinMounted() {
      await this.promiseGetAlumniRefresh;
      this.initMap();
    },
  },

  created() {
    this.de_makeAlumniBless = _.debounce(this.makeAlumniBless, HALF_DEBOUNCE_LATENCY);
    this.promiseGetAlumniRefresh = this.getAlumniRefresh();
    this.resetGetAlumniRefresh();
  },

  mounted() {
    const screen = new window.BulletJs('.map-barrage', {});
    this.itvlBullet = setInterval(() => {
      if (this.mg_currentBulletScreenList) {
        screen.push(this.mg_currentBulletScreenList);
      }
      this.ma_setIdxBulletScreenList();
    }, 1000);
    this.BlessMixinMounted();
  },

  beforeDestroy() {
    clearInterval(this.itvlGetAlumni);
    clearInterval(this.itvlBullet);
  },
};
// const getColor = (v) => {
//   if (v > 10000) {
//     return 'rgb(179, 255, 247)';
//   } else if (v > 5000 && v <= 10000) {
//     return 'rgb(134, 247, 240)';
//   } else if (v > 500 && v <= 5000) {
//     return 'rgb(49, 222, 222)';
//   } else if (v > 0 && v <= 500) {
//     return 'rgb(2, 170, 171)';
//   } else if (v == 0) {
//     return 'rgb(0, 118, 129)';
//   }
// };
const getColor = (v) => {
  if (v > 10000) {
    return 'rgb(0, 118, 129)';
  } else if (v > 5000 && v <= 10000) {
    return 'rgb(2, 170, 171)';
  } else if (v > 500 && v <= 5000) {
    return 'rgb(49, 222, 222)';
  } else if (v > 0 && v <= 500) {
    return 'rgb(134, 247, 240)';
  } else if (v == 0) {
    return 'rgb(179, 255, 247)';
  }
};
export default {
  name: 'Alumni',

  mixins: [BlessMixin],

  data() {
    return {
      geoData: [],
    };
  },
  components: {
    WayFindBar,
    Footer,
    Aside,
    TabBar,
    ToolBar,
    Spinner,
    PzButton,
    TrackerButton,
    // ChoroplethChart,
  },
  mounted() {
    //this.initMap();
  },

  methods: {
    initMap() {
      const countries = topojson.feature(countriesTopoJson, countriesTopoJson.objects.countries)
        .features;
      const data = this.mg_countriesBlessList;
      const _countries = countries.map((v) => {
        const matchingObject = data.find((vv) => vv.id == v.id);
        if (matchingObject) {
          return {
            ...v,
            value: matchingObject.value,
            properties: { name: matchingObject.name },
          };
        } else {
          return { ...v, value: 0 };
        }
      });

      new Chart(document.getElementById('geo').getContext('2d'), {
        type: 'choropleth',
        data: {
          labels: _countries.map((d) => d.properties.name),
          datasets: [
            {
              label: 'Countries',
              backgroundColor: (context) => {
                if (context.dataIndex == null) {
                  return null;
                }
                const value = context.dataset.data[context.dataIndex].value;
                return getColor(value);
              },
              graticuleBorderColor: 'red',
              data: _countries.map((d) => ({
                feature: d,
                value: d.value,
              })),
            },
          ],
        },
        options: {
          // plugins: {
          //   geo: {
          //     center: [40.7128, -74.006],
          //   },
          // },
          backgroundColor: 'steelblue',
          showOutline: false,
          showGraticule: false,
          legend: {
            display: false,
          },
          scale: {
            projection: 'equalEarth',
          },
        },
      });
    },
  },
};
